import {
  SHORTENER_RESOLUTION_CLEAR,
  SHORTENER_RESOLUTION_CLEAR_LINK_TO_RESOLVE,
  SHORTENER_RESOLUTION_SET_FILTERS_SELECTED,
} from '../../../../../actions/actionTypes';

const defaultState = true;

const filterByCustomer = (state = defaultState, action) => {
  switch (action.type) {
    case SHORTENER_RESOLUTION_SET_FILTERS_SELECTED:
      return action.payload.filterByCustomer;
    case SHORTENER_RESOLUTION_CLEAR_LINK_TO_RESOLVE:
    case SHORTENER_RESOLUTION_CLEAR:
      return defaultState;
    default:
      return state;
  }
};

export default filterByCustomer;
